module.exports = __webpack_public_path__ + "img/via-sign.6dd67c6b.svg";